export default {
  user_roles: {
    super: 'SUPER',
    admin: 'ADMIN',
    landlord: 'LANDLORD',
    tenant: 'TENANT'
  }
};
